import $ from 'jquery';
import {preventWrap} from "../../Libraries/Utils";


$('.js-news-ajax-filter').each((_, elem) => {
    const $filterRoot = $(elem);
    const targetSelector = $filterRoot.attr('data-target-list');
    const ajaxUrl = $filterRoot.attr('data-target-ajax-url');
    let $targetRoot;
    let $targetList;
    let $loadMoreRoot;
    let $loadMorebutton;

    try {
        $targetRoot = $(targetSelector);
    } catch (e) {
        console.error(`Error in ListFilter: Invalid target selector "${targetSelector}"`, e);
        return;
    }

    $targetList = $targetRoot.find('.tiles');
    $loadMoreRoot = $targetRoot.find('.js-load-more');
    $loadMorebutton = $loadMoreRoot.find('button');

    if ($targetList.length === 0) {
        console.error(`ListFilter: Target list not found for selector "${targetSelector}"`);
        return;
    }

    if (!ajaxUrl) {
        console.error('ListFilter: Missing data-target-ajax-url attribute');
        return;
    }

    let abortController = null;

    async function loadList(offset, categories) {
        let url = new URL(ajaxUrl, window.location.origin);
        url.searchParams.append('offset', offset);
        categories.forEach(cat => {
            url.searchParams.append('categories[]', cat);
        });

        if (abortController !== null) {
            abortController.abort();
        }

        $targetList.addClass('tiles--loading');

        abortController = new AbortController();
        let resp;
        try {
            resp = await fetch(url, {signal: abortController.signal});
        } catch (e) {
            if (e.name === 'AbortError') {
                return;
            }
            console.error('ListFilter: Fetch error', e);
            $targetList.removeClass('tiles--loading');
            return;
        }
        let html = await resp.text();
        abortController = null;

        $targetList.removeClass('tiles--loading');

        // <!-- RESULT_LIST_START_MARKER -->
        const startMarker = '<!-- RESULT_LIST_START_MARKER -->';
        const endMarker = '<!-- RESULT_LIST_END_MARKER -->';
        const startIndex = html.indexOf(startMarker);
        const endIndex = html.indexOf(endMarker);
        if (startIndex === -1 || endIndex === -1) {
            console.error('ListFilter: Invalid response format, missing markers');
            return;
        }
        const listHtml = html.substring(startIndex + startMarker.length, endIndex).trim();
        if (offset === 0) {
            $targetList.html(listHtml);
        } else {
            $targetList.append(listHtml);
        }

        // Check if more items are available
        const moreAvailableMarker = '<!-- RESULT_LIST_HAS_MORE -->';
        $loadMoreRoot.toggleClass('d-none', html.indexOf(moreAvailableMarker) === -1);
    }

    const $allButtons = $filterRoot.find('.button[data-category]');
    const $allButton = $filterRoot.find('.button[data-category="all"]');
    const $filterButtons = $allButtons.filter(':not([data-category="all"])');

    function getActiveCategories() {
        return $filterButtons.filter('.button--primary').toArray().map(btn => parseInt(btn.dataset.category));
    }

    $loadMorebutton.on('click', preventWrap(async (ev) => {
        const currentCount = $targetList.children().length;
        let categories = getActiveCategories();
        await loadList(currentCount, categories);
    }));

    $allButtons.on('click', preventWrap(async (ev) => {
        const $button = $(ev.currentTarget);
        const category = $button.attr('data-category');
        if (category === 'all') {
            $filterButtons.removeClass('button--primary');
            $filterButtons.addClass('button--outline-primary');
        } else {
            const activate = $button.hasClass('button--outline-primary');
            if (!ev.ctrlKey && !ev.metaKey) { // a bit convenience.
                const $otherActiveButtons = $filterButtons.not($button).filter('.button--primary');
                $otherActiveButtons.removeClass('button--primary');
                $otherActiveButtons.addClass('button--outline-primary');
                if ($otherActiveButtons.length > 0) {
                    if ($button.hasClass('button--primary')) {
                        return;
                    }
                }
            }
            $button.toggleClass('button--outline-primary', !activate);
            $button.toggleClass('button--primary', activate);
        }

        let categories = getActiveCategories();

        $allButton.toggleClass('button--black', categories.length === 0);
        $allButton.toggleClass('button--outline-black', categories.length !== 0);

        await loadList(0, categories);
    }));

});
